// src/redux/store.js
import { configureStore } from "@reduxjs/toolkit";
import tenantConfigReducer from "./slices/tenantConfigSlice";
import userReducer from "./slices/userSlice";
import menusReducer from "./slices/menusSlice";
import messageBarReducer from "./slices/messageBarSlice";
import loadingSlice from "./slices/loadingSlice";
import tenantBotsReducer from "./slices/tenantBotsSlice";
import tenantListReducer from "./slices/tenantListSlice";
import envReducer from "./slices/envSlice";
import globalDrawerReducer from "./slices/globalDrawerSlice";

const store = configureStore({
  reducer: {
    tenantConfig: tenantConfigReducer,
    user: userReducer,
    menus: menusReducer,
    messageBar: messageBarReducer,
    isLoading: loadingSlice,
    tenantBots: tenantBotsReducer,
    tenantList: tenantListReducer,
    env: envReducer,
    globalDrawer: globalDrawerReducer,
  },
  devTools: process.env.HOST_ENV !== "production",
});

export default store;
